<template>
    <div class="bubble speechBubble-right"
         :class="{ expanded: expanded, inactive: anyExpanded && !expanded && !mobile()}"
         ref="bubble"
         @mouseover="hover()"
         @mouseleave="endHover()"
         @click="onClick()"
    >
        <div class="bubbleContent">
            <p v-show="!expanded" class="shortMessage fat" v-html="shortMessage"></p>
            <p v-show="expanded" class="longMessage" v-html="longMessage"></p>
            <router-link v-show="hovered" :to="{name: 'article', params: {id: questionId}}" class="chooseLink">
                <div class="choose">
                    ODER...?
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import VueScrollTo from 'vue-scrollto'
    import BasicComponent from "@/components/BasicComponent";

    @Component({
        props: {
            questionId: Number,
            shortMessage: String,
            longMessage: String,
            anyExpanded: Boolean
        }
    })
    export default class SpeechBubble extends BasicComponent {

        data() {
            return {
                answers: require("@/assets/answers"),
                hovered: false,
            }
        }

        hover() {
            if (this.mobile() || this.hovered) return;
            this.onExpand();
        }

        endHover() {
            if (!this.hovered) return;
            this.onClose();
        }

        onExpand() {
            this.hovered = true;
            this.$emit("expand");
            this.trackEvent('Sprechblase Hover',
                this.$props.shortMessage);

            if (this.mobile()) {
                const element = this.$refs.bubble;
                Vue.nextTick(() => {
                    VueScrollTo.scrollTo(element, 0, {
                        cancelable: false
                    });
                });
            } else {

            }
        }

        onClose() {
            this.hovered = false;
            this.$emit("collapse");
        }

        onClick() {
            if (this.mobile()) {
                if (this.hovered) this.endHover();
                else {
                    this.onExpand();
                }
            }
        }

        scrollToBubble(bubble) {
            let bottomPosition = getViewportScrollTop() + bubble.getBoundingClientRect().top + bubble.offsetHeight;
            const scrollBottomPosition = getViewportScrollBottom();
            const diff = bottomPosition - scrollBottomPosition + 15;
            if (diff > 0) {
                VueScrollTo.scrollTo(this.$refs.bubble, 1000, {
                    cancelable: false
                });
                //window.scrollTo(0, getViewportScrollTop() + diff);
            }
        }

        get expanded() {
            return this.hovered;
        }
    }

    function getViewportScrollTop() {
        return (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
    }

</script>
<style scoped lang="scss">
    @import "@/stylesheets/Variables.scss";
    @import "@/stylesheets/SpeechBubble.scss";

    .bubble {
        @extend .homeSpeechBubble;

        &.expanded {
            min-height: $homeSpeechBubble-height;
            margin-bottom: -3000% !important;
            z-index: 5;
            background-color: white;

            @media screen and (max-width: 744px) {
                margin-bottom: 0 !important;
            }

        }

        &.inactive {
            opacity: 0.2;
        }

        img {
            display: block;
        }

        .bubbleContent {
            position: relative;
            min-height: 100%;

            &:hover {
            }
            p {
                font-size: 24px;

                @media screen and (max-width: 280px) {
                    font-size: 8vw;
                }
            }

            .shortMessage, .longMessage {
                display: inline-block;
            }

            .shortMessage {
                text-transform: uppercase;
            }

            .longMessage {
                hyphens: auto;
            }

            .chooseLink {
                color: black;
                text-decoration: none;

                .choose {
                    $chooseHeight: 50px;

                    width: 80%;
                    margin: 10px auto 0;
                    height: $chooseHeight;

                    border: 7px solid black;

                    font-size: 24px;
                    font-weight: 600;

                    vertical-align: center;
                    line-height: 38px;

                    //background: url(../assets/choose.svg) no-repeat center;

                    &:hover {
                        //background-image: url(../assets/choose_hover.svg);
                        color: white;
                        background-color: black;
                    }
                }
            }

        }
    }
</style>
